// extracted by mini-css-extract-plugin
export var backgroundDiv = "styles-module--backgroundDiv--aca47";
export var description = "styles-module--description--0e07b";
export var innerContainer = "styles-module--innerContainer--b2d23";
export var link = "styles-module--link--03e54";
export var title = "styles-module--title--f2739";